import { createIcon } from '@chakra-ui/react';

export const CheckIcon = createIcon({
  displayName: 'CheckIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="14"
        // height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <g clipPath="url(#clip0_2378_48234)">
          <path
            d="M5.24911 9.43339L2.81661 7.00089L1.98828 7.82339L5.24911 11.0842L12.2491 4.08422L11.4266 3.26172L5.24911 9.43339Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_2378_48234">
            <rect width="14" height="14" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  ),
});
